// extracted by mini-css-extract-plugin
export default {"cls1":"ucICpm6XhejiXqj6rgFp","cls2":"Cu1ILTsDyc0uXLoF10tS ucICpm6XhejiXqj6rgFp"};